import { Component, OnInit } from '@angular/core';

import { ModeloGps } from "../shared/modelo-gps.model";
import { modeloGpsModuleName } from "../shared/data.service";
import { ModeloGpsApiService } from "../shared/modelo-gps-api.service";
import { ModeloGpsNavigationService } from "../shared/modelo-gps-navigation.service";
import { ModeloGpsService } from "../shared/modelo-gps.service";
import { UtilService } from "../../../shared/services/util.service";
import {rastreamentosModuleName} from "../../shared/data.service";
import {configuracaoModuleName} from "../../../shared/services/data.service";
import {RastreamentoService} from "../../shared/rastreamento.service";

@Component({
    template: require('./modelo-gps-list.component.html'),
    styles: [require('./modelo-gps-list.component.css')]
})
export class ModeloGpsListComponent implements OnInit {
    list: ModeloGps[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    modelosGpsModuleName: any = modeloGpsModuleName;
    module: any = rastreamentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    constructor(
        private _modelosGpsApiService: ModeloGpsApiService,
        private _modelosGpsService: ModeloGpsService,
        private _modeloGpsNavigationService: ModeloGpsNavigationService,
        private _rastreamentoService: RastreamentoService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._modelosGpsService.clearSessionStorage();
        this._modeloGpsNavigationService.goToNew();
    }

    clickEdit(item: ModeloGps) {
        this._modelosGpsService.clearSessionStorage();
        this._modeloGpsNavigationService.goToEdit(item.id);
    }

    clickGoToConfig() {
        this._rastreamentoService.goToSetting();
    }

    clickDelete(item: ModeloGps) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._modelosGpsApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._modelosGpsApiService.onDelete(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/modelos-gps/modelo-gps-list/modelo-gps-list.component.ts
 **/